<template>
  <div>
    <el-dialog
      :title="groupForm.id ? $t('machineGroup.edit') : $t('machineGroup.add')"
      :visible="visible"
      width="35%"
      top="9vh"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @closed="onClosed"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form
          :label-position="labelPosition"
          :rules="rules"
          ref="groupFormRef"
          label-width="80px"
          :model="groupForm"
        >
          <el-form-item :label="$t('machineGroup.name')" prop="name">
            <el-input v-model="groupForm.name" :placeholder="$t('machineGroup.pName')" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('machineGroup.remarks')" style="margin-bottom: 0">
            <el-input type="textarea" :rows="4" v-model="groupForm.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="handleSubmit">{{ $t("common.definite") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "AddMachineGroupDialog",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      // 用于编辑时回填，新增时可不传或传空对象
      group: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        labelPosition: "top",
        loadingForm: false,
        groupForm: {
          id: "",
          name: "",
          remarks: ""
        },
        rules: {
          name: [
            {
              required: true,
              message: this.$t("machineGroup.pName"),
              trigger: "blur"
            }
          ]
        }
      };
    },
    watch: {
      // 同步外部传入的分组数据到内部表单
      group: {
        deep: true,
        immediate: true,
        handler(val) {
          const init = { id: "", name: "", remarks: "" };
          const src = val || {};
          Object.keys(init).forEach(k => {
            this.groupForm[k] = src[k] || init[k];
          });
        }
      }
    },
    methods: {
      onClosed() {
        // 关闭后清空表单
        this.clearForm();
        this.$emit("update:visible", false);
      },
      handleCancel() {
        this.$emit("update:visible", false);
      },
      handleSubmit() {
        this.$refs.groupFormRef.validate(valid => {
          if (!valid) return;
          this.loadingForm = true;
          let url = this.$url.MachineGroup.insert;
          let method = this.$method.post;
          if (this.groupForm.id) {
            url = this.$url.MachineGroup.update;
            method = this.$method.put;
          }
          this.$api
            .request(url, method, this.groupForm)
            .then(res => {
              if (res.code === 0) {
                // 通知成功，向外派发成功事件，附带后端返回或提交数据
                this.$notify({
                  title: this.$t("common.tip"),
                  message:
                    (this.groupForm.id ? this.$t("machineGroup.up") : this.$t("machineGroup.save")) +
                    this.$t("machineGroup.groupS"),
                  type: "success"
                });
                this.$emit("success", res.data || { ...this.groupForm });
                this.$emit("update:visible", false);
              }
            })
            .finally(() => {
              this.loadingForm = false;
            });
        });
      },
      clearForm() {
        if (this.$refs.groupFormRef) {
          this.$refs.groupFormRef.clearValidate();
        }
        this.groupForm = { id: "", name: "", remarks: "" };
      }
    }
  };
</script>

<style scoped></style>
